import React from 'react';
import { RefreshCw } from 'lucide-react';

/* ── Switch Modal ── */
const SwitchModal = ({ onClose, onSwitchNow, switchLoading }) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      <div className="wp-switch-modal__icon"><RefreshCw size={28} /></div>
      <h3 className="wp-switch-modal__title">Switch to Customer</h3>
      <p className="wp-switch-modal__desc">
        Login with your customer account to book services. You can switch back anytime.
      </p>
      <div className="wp-switch-modal__actions">
        <button className="wp-modal__cancel" onClick={onClose}>Cancel</button>
        <button
  className="wp-switch-modal__confirm"
  onClick={onSwitchNow}
  disabled={switchLoading}
>
  {switchLoading ? (
    <>
      {/* <span className="wh-btn-spinner"></span> */}
      <span>Switching...</span>
    </>
  ) : (
    <>
      <RefreshCw size={15} />
      <span>Switch Now</span>
    </>
  )}
</button>
      </div>
    </div>
  </div>
);

export default SwitchModal;